window.app.filter("quarterFull", [
  function() {
    // In the return function, we must pass in a single parameter which will be the data we will work on.
    // We have the ability to support multiple other parameters that can be passed into the filter optionally
    return function(input, format) {
      if (!window.moment) {
        return "";
      }
      // Do filter work here
      var m = window.moment.utc(input, format);
      return (
        window.moment.localeData().ordinal(m.quarter()) +
        " Quarter, " +
        m.year()
      );
    };
  }
]);

window.app.filter("yearFull", [
  function() {
    // In the return function, we must pass in a single parameter which will be the data we will work on.
    // We have the ability to support multiple other parameters that can be passed into the filter optionally
    return function(input, format) {
      // Do filter work here
      return window.moment && window.moment.utc(input, format).year();
    };
  }
]);

window.app.filter("moment", [
  function() {
    // In the return function, we must pass in a single parameter which will be the data we will work on.
    // We have the ability to support multiple other parameters that can be passed into the filter optionally
    return function(input, format) {
      // Do filter work here
      return window.moment && window.moment.utc(input).format(format);
    };
  }
]);

window.app.filter("random", [
  function() {
    // In the return function, we must pass in a single parameter which will be the data we will work on.
    // We have the ability to support multiple other parameters that can be passed into the filter optionally
    return function(input) {
      // Do filter work here
      return Math.round(Math.random() * input);
    };
  }
]);



// WEBPACK FOOTER //
// ./src/filters/moment.js